import React, { useContext, useEffect, useState, useRef } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { FaEdit, FaEye, FaEyeDropper, FaRupeeSign } from "react-icons/fa";
import { FaFileExport } from "react-icons/fa";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import Select from "react-select";
import {
    CalenderFilterEnum,
    DashboardExpenseReportEnum,
    globalSelectStyles,
    ReportEnum,
} from "../../middleware/enum";
import * as XLSX from "xlsx";
import { FaBook } from "react-icons/fa";
import dayjs from "dayjs";
import {
    ChangeLeaveStatus,
    DeleteLeave,
    GetLeaveList,
} from "../../services/LeaveManagement/LeaveManage";
import {
    GetAccountabilityReport,
    GetAttendanceReport,
    GetClientFinancialReport,
    GetJobReport,
    GetKRAReport,
    GetProfitabilityReport,
    GetProfitLossReport,
    GetTaskReport,
    GetTeamPerformanceReport,
} from "../../services/Reports/ReportsApi";
import NoResultFoundModel from "../../components/common/NoDataFound";
import PaginationComponent from "../../components/common/PaginationModal";
import {
    GetClientLookupList,
    GetClientProjectLookupListReport,
} from "../../services/Client/ClientApi";
import { GetUserLookupListAllocated } from "../../services/Staff/StaffApi";
import CalendarFilter from "../../components/common/CalenderFilter";
import { GetJobLookupList } from "../../services/Job/JobApi";
import { GetStatusLookupList } from "../../services/SettingApi/Statuses/StatusesApi";
import { GetServiceLookupList } from "../../services/SettingApi/Service/ServiceApi";
import { GetProjectStageLookupList } from "../../services/SettingApi/ProjectStage/ProjectStageApi";
import { GetWorkingHourLookupList } from "../../services/TimeSlot/TimeSlotApi";
import { AttandaceStatus } from "../../middleware/Utils";
import Utils from "../../middleware/Utils";
import AttendanceAddUpdateModal from "../Attendance/AttendanceAddUpdateModal";
import JobReportListComponent from "./JobReportList";
import ProjectReportListComponent from "./ProjectReportList";
import AttendanceReportListComponent from "./AttendanceReportList";
import ClientReportListComponent from "./ClientReportList";
import ExpenseReportListComponent from "./ExpenseReportList";
import TenderReportListComponent from "./TenderReportList";
import ProfitLossReportComponent from "./ProfitLossReport";
const allTabs = [
    {
        id: DashboardExpenseReportEnum.TenderReport,
        label: "Tender Report",
        accessKey: "ClientAcountabilityReportsCanView",
        compareName: "TenderReport",
    },
    {
        id: DashboardExpenseReportEnum.ExpenseReport,
        label: "Expense Report",
        accessKey: "ClientJobReportsCanView",
        compareName: "ExpenseReport",
    },
];



// Initial visible tab ids
const initialVisibleTabs = [2, 1, 4, 5, 3, 7, 8];

function DashboardExpenseList() {
    const navigate = useNavigate();
    const location = useLocation();
    const { userKeyID } = JSON.parse(localStorage.getItem("login"));
    const [searchParams] = useSearchParams();

    //Context
    const { setLoader } = useContext(LoaderContext);
    const { authDetails, pageSize, PanalModuleName, defaultAccess } =
        useContext(AuthContext);

    //====================state=============================
    //common state
    const [valueSearch, setValueSearch] = useState(null);
    const [tableRows, setTableRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);


    const [expandedProjects, setExpandedProjects] = useState({});
    const [expandedServices, setExpandedServices] = useState({});
    const [expandedJobs, setExpandedJobs] = useState({});
    const [clientLookupList, setClientLookupList] = useState([]);
    const [selectedJobKeyID, setSelectedJobKeyID] = useState(
        location?.state?.selectedJobKeyID || null
    ); // State for selected job

    //state for attendance
    //List Params
    const [LeaveSearch, setLeaveSearch] = useState("");
    const [LeaveList, setLeaveList] = useState([]);
    const [LeaveListCount, setLeaveListCount] = useState(-1);
    const [LeaveCurrentPage, setLeaveCurrentPage] = useState(1);
    const [OpenRemarkModel, setOpenViewRemark] = useState(false);
    const [modelRequestData, setModelRequestData] = useState({
        KeyID: null,
        Action: null,
        status: null,
        Name: null,
        remark: null,
    });
    //state attendance ends

    const [selectedJobName, setSelectedJobName] = useState(null);
    const skipUseEffectRef = useRef(false);
    const [timeSlotList, setTimeSlotList] = useState([]);
    const [selectedServiceKeyID, setSelectedServiceKeyID] = useState(null);

    const [fromDate, setFromDate] = useState(dayjs().startOf("week"));
    const [toDate, setToDate] = useState(dayjs().endOf("week"));
    // Track which tabs are visible
    const [visibleTabs, setVisibleTabs] = useState(initialVisibleTabs);
    const [serviceLookupList, setServiceLookupList] = useState([]);
    const [selectedTaskUser, setSelectedTaskUser] = useState(
        location?.state?.selectedTaskUser || null
    ); // State for selected user for task report
    const [projectData, setProjectData] = useState(null);
    const [clientObj, setClientObj] = useState({});
    const [activeTab, setActiveTab] = useState(() => {
        const storedTab = Number(localStorage.getItem("ReportselectedTab"));
        const storedPath = localStorage.getItem("ReportCurrentPath");

        const defaultTab = storedPath === "/report" && storedTab ? storedTab : 2;
        // If the stored tab is not in visibleTabs, fallback to first visible tab
        if (!initialVisibleTabs.includes(defaultTab)) {
            return initialVisibleTabs[0];
        }
        return defaultTab;
    });

    const toggleProject = (id) => {
        setExpandedProjects((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const toggleService = (id) => {
        setExpandedServices((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const toggleJob = (id) => {
        setExpandedJobs((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    //Reports
    const [projectList, setprojectList] = useState([]);
    const [projectSearch, setprojectSearch] = useState("");
    const [projectListCount, setprojectListCount] = useState(-1);
    const [projectCurrentPage, setprojectCurrentPage] = useState(1);

    //Task
    const [taskList, setTaskList] = useState([]);
    const [taskSearch, setTaskSearch] = useState("");
    const [taskListCount, setTaskListCount] = useState(-1);
    const [taskCurrentPage, setTaskCurrentPage] = useState(1);

    //Profitability Report
    const [profitabilityList, setProfitabilityList] = useState([]);
    const [profitabilitySearch, setProfitabilitySearch] = useState("");
    const [profitabilityListCount, setProfitabilityListCount] = useState(-1);
    const [profitabilityCurrentPage, setProfitabilityCurrentPage] = useState(1);

    //Team Performance
    const [teamPerforanceList, setTeamFerformanceList] = useState([]);
    const [teamPerformanceSearch, setTeamPerformanceSearch] = useState("");
    const [teamPerformanceListCount, setTeamPerformanceListCount] = useState(-1);
    const [teamPerformanceCurrentPage, setTeamPerformanceCurrentPage] =
        useState(1);

    //Attendance Report
    const [AttendanceList, setAttendanceList] = useState([]);
    const [AttendanceListSearch, setAttendanceListSearch] = useState("");
    const [AttendanceListCount, setAttendanceListCount] = useState(-1);
    const [AttendanceListCurrentPage, setAttendanceListCurrentPage] = useState(1);
    const [openLeavePopUpModelOpen, setOpenLeavePopupModel] = useState(false);
    const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
    //Client Financial Report
    const [ClientFinancialList, setClientFinancialList] = useState([]);
    const [ClientFinancialListSearch, setClientFinancialListSearch] =
        useState("");
    const [ClientFinancialListCount, setClientFinancialListCount] = useState(-1);
    const [ClientFinancialListCurrentPage, setClientFinancialListCurrentPage] =
        useState(1);

    //Job Report
    const [JobReportSearch, setJobReportSearch] = useState("");
    const [JobReportList, setJobReportList] = useState([]);
    const [JobReportListCount, setJobReportListCount] = useState(-1);
    const [JobReportCurrentPage, setJobReportCurrentPage] = useState(1);
    //KRA
    const [KRAReportSearch, setKRAReportSearch] = useState("");
    const [KRAReportList, setKRAReportList] = useState([]);
    const [KRAReportListCount, setKRAReportListCount] = useState(-1);
    const [KRAReportCurrentPage, setKRAReportCurrentPage] = useState(1);

    //Project
    const [ProjectLookUpList, setProjectLookUpList] = useState([]);
    const [selectedProjectID, setSelectedProjectID] = useState(null); // Step 1: State for selected project ID
    const [selectedTaskProjectID, setSelectedTaskProjectID] = useState(null); // Step 1: State for selected project ID
    const [selectedProfitabilityProjectID, setSelectedProfitabilityProjectID] =
        useState(null); // Step 1: State for selected project ID

    const [userLookupList, setUserLookupList] = useState([]);
    const [JobLookupList, setJobLookupList] = useState([]);

    const [selecteduserKeyID, setSelecteduserKeyID] = useState(null); // Step 1: State for selected project ID
    const [attandanceStatusID, setAttandanceStatusID] = useState(1); // Step 1: State for selected project ID

    const [ProjectStageLookupList, setProjectStageLookupList] = useState([]);
    const [selectedClientID, setSelectedClientID] = useState(null);
    const [selectedProjectStageID, setSelectedProjectStageID] = useState(null);
    const [selectedStatusID, setSelectedStatusID] = useState(null);

    const [SelectedserviceKeyID, setSelectedserviceKeyID] = useState(null);
    //=======================useEffect==============================
    useEffect(() => {
        localStorage.setItem("ReportselectedTab", activeTab);
        localStorage.setItem("ReportCurrentPath", "/report");
    }, [activeTab]);

    useEffect(() => {
        const tab =
            parseInt(searchParams.get("tab")) || ReportEnum.PaymentSummaryReport; // default to 1st tab
        handleChangeTab(tab);
    }, []);

    useEffect(() => {
        if (
            selectedJobKeyID &&
            !JobLookupList.find((item) => item.value === selectedJobKeyID)
        ) {
            setJobLookupList((prev) => [
                ...prev,
                { label: selectedJobName, value: selectedJobKeyID },
            ]);
        }
    }, [selectedJobKeyID, selectedJobName]);

    useEffect(() => {
        const tabFromUrl = parseInt(searchParams.get("tab"));
        if (tabFromUrl && !isNaN(tabFromUrl)) {
            setActiveTab(tabFromUrl); // Set the active tab based on the URL parameter
        } else {
            setActiveTab(1); // Fallback to the default tab
        }
    }, [searchParams]);

    useEffect(() => {
        const storedTab = Number(localStorage.getItem("ReportselectedTab"));
        if (storedTab && visibleTabs.includes(storedTab)) {
            setActiveTab(storedTab);
        } else {
            setActiveTab(initialVisibleTabs[1]); // Fallback to the first visible tab
        }
    }, []);



    //=======================funtions==============================
    //Tab Change Function
    const handleChangeTab = (tab) => {
        setActiveTab(tab);

        // Set "This Week" by default only when tab 6 is selected
        if (tab === ReportEnum.ProfitabilityReport) {
            const defaultStartDate = dayjs().startOf("week").format("YYYY-MM-DD");
            const defaultEndDate = dayjs().endOf("week").format("YYYY-MM-DD");

            setFromDate(defaultStartDate);
            setToDate(defaultEndDate);
            setProfitabilityCurrentPage(1);
            // GetProfitabilityReportData(
            //   1,
            //   taskSearch,
            //   selecteduserKeyID,
            //   selectedJobKeyID,
            //   defaultStartDate,
            //   defaultEndDate,
            //   selectedProfitabilityProjectID
            // );
        } else {
            // For all other tabs, clear the date
            setFromDate(null);
            setToDate(null);
        }

        navigate(`?tab=${tab}`); // Update the URL
    };

    const handleSearchFunction = (searchValue) => {
        if (activeTab === ReportEnum.JobReport) {
            setJobReportSearch(searchValue);
            setJobReportCurrentPage(1);
            if (searchValue?.trim() === "") {
                GetJobReportListData(1); // Fetch all job reports
            } else {
                GetJobReportListData(1, searchValue); // Fetch filtered job reports
            }
        } else if (activeTab === ReportEnum.ProjectReport) {
            setprojectSearch(searchValue);
            setprojectCurrentPage(1);
            if (searchValue?.trim() === "") {
                GetAccountabilityReportData(1); // Fetch all accountability reports
            } else {
                GetAccountabilityReportData(1, searchValue); // Fetch filtered accountability reports
            }
        } else if (activeTab === ReportEnum.TaskReport) {
            setTaskSearch(searchValue);
            setTaskCurrentPage(1);
            if (searchValue?.trim() === "") {
                GetTaskReportData(
                    1,
                    "",
                    selectedTaskUser,
                    selectedJobKeyID,
                    fromDate,
                    toDate,
                    null,
                    selectedTaskProjectID
                ); // Fetch all task reports
            } else {
                GetTaskReportData(
                    1,
                    searchValue,
                    selectedTaskUser,
                    selectedJobKeyID,
                    fromDate,
                    toDate,
                    null,
                    selectedTaskProjectID
                ); // Fetch filtered task reports
            }
        } else if (activeTab === ReportEnum.PaymentSummaryReport) {
            setClientFinancialListSearch(searchValue);
            setClientFinancialListCurrentPage(1);
            if (searchValue?.trim() === "") {
                GetClientFinancialReportData(1); // Fetch all client financial reports
            } else {
                GetClientFinancialReportData(1, searchValue); // Fetch filtered client financial reports
            }
        } else if (activeTab === ReportEnum.TeamPerformanceReport) {
            setTeamPerformanceSearch(searchValue);
            setTeamPerformanceCurrentPage(1);
            if (searchValue?.trim() === "") {
                GetTeamPerformanceReportData(1); // Fetch all team performance reports
            } else {
                GetTeamPerformanceReportData(1, searchValue); // Fetch filtered team performance reports
            }
        } else if (activeTab === ReportEnum.KRAReport) {
            setKRAReportSearch(searchValue);
            setKRAReportCurrentPage(1);
            if (searchValue?.trim() === "") {
                GetKRAReportListData(1); // Fetch all KRA reports
            } else {
                GetKRAReportListData(1, searchValue); // Fetch filtered KRA reports
            }
        } else if (activeTab === ReportEnum.ProfitLossReport) {
            setValueSearch(searchValue);
            setCurrentPage(1);

            GetProfitLossReportData(1, searchValue, fromDate, toDate);
        } else if (activeTab === ReportEnum.AttendanceReport) {
            setAttendanceListSearch(searchValue);
            setAttendanceListCurrentPage(1);
            if (searchValue?.trim() === "") {
                GetAttendanceReportData(
                    1,
                    "",
                    fromDate,
                    toDate,
                    selecteduserKeyID,
                    attandanceStatusID === 1 ? "Present" : "Absent"
                ); // Fetch all attendance reports
            } else {
                GetAttendanceReportData(
                    1,
                    searchValue,
                    fromDate,
                    toDate,
                    selecteduserKeyID,
                    attandanceStatusID === 1 ? "Present" : "Absent"
                ); // Fetch filtered attendance reports
            }
        }
    };

    // Change Page Button
    const HandlePageChange = async (pageNumber) => {
        if (activeTab === ReportEnum.JobReport) {
            setJobReportCurrentPage(pageNumber);
            await GetJobReportListData(pageNumber); // Call with selected page
        } else if (activeTab === ReportEnum.ProjectReport) {
            setprojectCurrentPage(pageNumber);
            await GetAccountabilityReportData(pageNumber);
        } else if (activeTab === ReportEnum.TaskReport) {
            setTaskCurrentPage(pageNumber);
            await GetTaskReportData(
                pageNumber,
                taskSearch,
                selectedTaskUser,
                selectedJobKeyID,
                fromDate,
                toDate,
                null,
                selectedTaskProjectID
            );
        } else if (activeTab === ReportEnum.PaymentSummaryReport) {
            setClientFinancialListCurrentPage(pageNumber);
            await GetClientFinancialReportData(pageNumber);
        } else if (activeTab === ReportEnum.TeamPerformanceReport) {
            setTeamPerformanceCurrentPage(pageNumber);
            await GetTeamPerformanceReportData(pageNumber);
        } else if (activeTab === ReportEnum.AttendanceReport) {
            setAttendanceListCurrentPage(pageNumber);
            await GetAttendanceReportData(
                pageNumber,
                AttendanceListSearch,
                fromDate,
                toDate,
                selecteduserKeyID, // ✅ Pass selected user key
                attandanceStatusID === 1 ? "Present" : "Absent"
            );
        } else if (activeTab === ReportEnum.KRAReport) {
            setKRAReportCurrentPage(pageNumber);
            await GetKRAReportListData(pageNumber);
        } else if (activeTab === ReportEnum.ProfitLossReport) {
            setCurrentPage(pageNumber);
            await GetProfitLossReportData(pageNumber);
        }
    };

    // Modify the handleProjectChange function
    const handleProjectChange = (selectedOption) => {
        const projectID =
            selectedOption && selectedOption.value !== null
                ? selectedOption.value
                : null;
        setSelectedTaskProjectID(projectID);

        // Refresh Job list according to projectID (null = all jobs)
        GetJobLookupListData(projectID);
        setTaskCurrentPage(1);
        // Also reload task data
        GetTaskReportData(
            1,
            taskSearch,
            selectedTaskUser,
            selectedJobKeyID,
            fromDate,
            toDate,
            null,
            projectID
        );
    };



    const handleJobProjectChange = (selectedOption) => {
        const projectID = selectedOption ? selectedOption.value : null;
        setSelectedProjectID(projectID);
        setJobReportCurrentPage(1);
        GetJobReportListData(
            1,
            JobReportSearch,
            projectID, // new project
            selectedStatusID,
            selectedServiceKeyID,
            selectedTaskUser // pass user filter
        );
    };

    // Modify the handleJobStatusChange function
    const handleJobStatusChange = (selectedOption) => {
        const statusID = selectedOption ? selectedOption.value : null;
        setSelectedStatusID(statusID);
        setJobReportCurrentPage(1);
        GetJobReportListData(
            1,
            JobReportSearch,
            selectedProjectID,
            statusID, // new status
            selectedServiceKeyID,
            selectedTaskUser
        );
    };

    const handleServiceChange = (selectedOption) => {
        const serviceKeyID = selectedOption ? selectedOption.value : null;
        setSelectedserviceKeyID(serviceKeyID);
        setJobReportCurrentPage(1);
        GetJobReportListData(
            1,
            JobReportSearch,
            selectedProjectID,
            selectedStatusID,
            serviceKeyID, // new service
            selectedTaskUser
        );
    };

    const handleTeamServiceChange = (selectedOption) => {
        const serviceKeyID = selectedOption ? selectedOption.value : null; // Get the selected service ID
        setSelectedServiceKeyID(serviceKeyID); // Update state with selected service ID
        setTeamPerformanceCurrentPage(1);
        GetTeamPerformanceReportData(
            1,
            teamPerformanceSearch,
            fromDate,
            toDate,
            serviceKeyID,
            selectedTaskProjectID // Pass the current project ID
        ); // Call with selected service ID
    };

    const handleTeamProjectChange = (selectedOption) => {
        const projectID = selectedOption ? selectedOption.value : null; // Get the selected project ID
        setSelectedTaskProjectID(projectID); // Update state with selected project ID
        setTeamPerformanceCurrentPage(1);
        GetTeamPerformanceReportData(
            1,
            teamPerformanceSearch,
            fromDate,
            toDate,
            selectedServiceKeyID, // Pass the current service ID
            projectID // Pass projectID here
        ); // Call with selected project ID
    };

    const GetJobReportListData = async (
        i,
        searchKeyword,
        clientProjectID,
        statusKeyID,
        serviceKeyID,
        getUserKeyID
    ) => {
        const pageNoList = i - 1;
        try {
            setLoader(true);
            let response = await GetJobReport({
                moduleName: PanalModuleName,
                pageSize: pageSize,
                pageNo: pageNoList,
                searchKeyword:
                    searchKeyword === undefined ? JobReportSearch : searchKeyword,
                userKeyID: authDetails.userKeyID,
                clientProjectID: clientProjectID,
                statusKeyID: statusKeyID,
                serviceKeyID: serviceKeyID,
                getUserKeyID: getUserKeyID,
            });
            if (response.statusCode === 200) {
                setLoader(false);
                const list = response.responseData?.data;
                setJobReportListCount(response.totalCount);
                setJobReportList(list);
            } else {
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };





    const handleExportPandLReport = () => {
        const wb = XLSX.utils.book_new();

        const titleText = "Title: Profit Loss Report";
        const headers = [
            "Project Name",
            "Client To Cost",
            "TechnoLand to Cost",
            "Client To Cost (P&L)",
            "TechnoLand to Cost (P&L)",
        ];

        const data = tableRows.map((row) => [
            row.projectName || "-",
            row.clientToCost || "-",
            row.technolandToCost || "-",
            row.clientToCostPnL || "-",
            row.technolandToCostPnL || "-",
        ]);

        const ws_data = [[titleText], [], headers, ...data];

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merge title row
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center", vertical: "center" },
        };

        // Header row styling (row 2 / index 2)
        headers.forEach((_, col) => {
            const cellAddr = XLSX.utils.encode_cell({ c: col, r: 2 });
            if (ws[cellAddr]) {
                ws[cellAddr].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    fill: { fgColor: { rgb: "CFE2F3" } }, // Light blue
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                };
            }
        });

        // Data row styling
        for (let r = 3; r < data.length + 3; r++) {
            for (let c = 0; c < headers.length; c++) {
                const cellAddr = XLSX.utils.encode_cell({ c, r });
                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { color: { rgb: "000000" } },
                        alignment: { horizontal: "left", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };

                    // Zebra styling for alternating rows
                    if ((r - 3) % 2 === 1) {
                        ws[cellAddr].s.fill = { fgColor: { rgb: "F9F9F9" } };
                    }
                }
            }
        }

        // Column widths for readability
        ws["!cols"] = headers.map((h) => ({ wch: h.length + 8 }));

        XLSX.utils.book_append_sheet(wb, ws, "Profit Loss Report");
        XLSX.writeFile(wb, "Profit_Loss_Report.xlsx");
    };

    //KRAReport
    const GetKRAReportListData = async (i, searchKeyword) => {
        const pageNoList = i - 1;
        try {
            setLoader(true);
            let response = await GetKRAReport({
                pageSize: pageSize,
                pageNo: pageNoList,
                searchKeyword:
                    searchKeyword === undefined ? KRAReportSearch : searchKeyword,
                userKeyID: authDetails.userKeyID,
            });
            if (response.statusCode === 200) {
                setLoader(false);
                const list = response.responseData?.data;
                setKRAReportListCount(response.totalCount);
                setKRAReportList(list);
            } else {
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    //Project
    const GetAccountabilityReportData = async (
        i = 1,
        searchKeyword,
        projectStageKeyID
    ) => {
        const pageNoList = i - 1;
        try {
            setLoader(true);
            let response = await GetAccountabilityReport({
                moduleName: null,
                pageSize: pageSize,
                pageNo: pageNoList,
                searchKeyword:
                    searchKeyword === undefined ? projectSearch : searchKeyword,
                userKeyID: authDetails.userKeyID,
                projectStageKeyID,
            });
            if (response.statusCode === 200) {
                setLoader(false);
                const list = response.responseData?.data;
                setprojectListCount(response.totalCount);
                setprojectList(list);
            } else {
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    //Task
    const GetTaskReportData = async (
        i = 1,
        searchKeyword,
        getUserKeyID,
        jobKeyID,
        fromDate,
        toDate,
        isCompleted,
        clientProjectID
    ) => {
        const pageNoList = i - 1;
        try {
            setLoader(true);

            let response = await GetTaskReport({
                moduleName: null,
                pageSize: pageSize,
                pageNo: pageNoList,
                searchKeyword: searchKeyword === undefined ? taskSearch : searchKeyword,
                userKeyID: authDetails.userKeyID,
                getUserKeyID:
                    getUserKeyID === undefined
                        ? location?.state?.selectedTaskUser
                        : getUserKeyID,
                jobKeyID:
                    jobKeyID === undefined ? location?.state?.selectedJobKeyID : jobKeyID,
                fromDate: fromDate === undefined ? location?.state?.fromDate : fromDate, // Use the passed fromDate or a default
                toDate: toDate === undefined ? location?.state?.toDate : toDate, // Use the passed toDate or a default
                clientProjectID: clientProjectID,
                isCompleted: isCompleted,
            });
            if (response.statusCode === 200) {
                setLoader(false);
                const list = response.responseData?.data;
                setTaskListCount(response.totalCount);
                setTaskList(list);
            } else {
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    //Client Financial Report/Payment Summary Report
    const GetClientFinancialReportData = async (
        i = 1,
        searchKeyword,
        clientKeyID,
        projectStageKeyID
    ) => {
        const pageNoList = i - 1; // Adjust for zero-based index
        try {
            setLoader(true);
            let response = await GetClientFinancialReport({
                moduleName: null,
                pageSize: pageSize,
                pageNo: pageNoList || 0,
                searchKeyword:
                    searchKeyword === undefined
                        ? ClientFinancialListSearch
                        : searchKeyword,
                userKeyID: authDetails.userKeyID,
                clientKeyID: clientKeyID,
                projectStageKeyID: projectStageKeyID,
            });
            if (response.statusCode === 200) {
                setLoader(false);
                const list = response.responseData?.data;
                setClientFinancialListCount(response.totalCount);
                setClientFinancialList(list);
            } else {
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    //Profit Loss Report
    const GetProfitLossReportData = async (
        i = 1,
        searchKeyword,
        fromDate,
        toDate
    ) => {
        const pageNoList = i - 1;
        try {
            setLoader(true);
            let response = await GetProfitLossReport({
                pageSize: pageSize,
                pageNo: pageNoList || 0,
                searchKeyword:
                    searchKeyword === undefined ? teamPerformanceSearch : searchKeyword,
                userKeyID: authDetails.userKeyID,
                fromDate: fromDate, // Use the passed fromDate or a default
                toDate: toDate, // Use the passed toDate or a default
            });
            if (response.statusCode === 200) {
                setLoader(false);
                const list = response.responseData?.data;
                // setTeamPerformanceListCount(response.totalCount);
                // setTeamFerformanceList(list);
                setTableRows(list);
                setTotalCount(response.totalCount);
            } else {
                setLoader(false);
                setTotalCount(0);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const GetTeamPerformanceReportData = async (
        i = 1,
        searchKeyword,
        fromDate,
        toDate,
        serviceKeyID,
        clientProjectID
    ) => {
        const pageNoList = i - 1;
        try {
            setLoader(true);
            let response = await GetProfitLossReport({
                moduleName: null,
                pageSize: pageSize,
                pageNo: pageNoList || 0,
                searchKeyword:
                    searchKeyword === undefined ? teamPerformanceSearch : searchKeyword,
                userKeyID: authDetails.userKeyID,
                fromDate: fromDate, // Use the passed fromDate or a default
                toDate: toDate, // Use the passed toDate or a default
                serviceKeyID: serviceKeyID, // Pass the selected service ID or null
                clientProjectID: clientProjectID,
            });
            if (response.statusCode === 200) {
                setLoader(false);
                const list = response.responseData?.data;
                setTeamPerformanceListCount(response.totalCount);
                setTeamFerformanceList(list);
            } else {
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const GetAttendanceReportData = async (
        i = 1,
        searchKeyword,
        fromDate,
        toDate,
        getUserKeyID,
        attendanceStatus
    ) => {
        const pageNoList = i - 1;
        try {
            setLoader(true);
            let response = await GetAttendanceReport({
                moduleName: null,
                pageSize: pageSize,
                pageNo: pageNoList || 0,
                searchKeyword:
                    searchKeyword === undefined ? AttendanceListSearch : searchKeyword,
                userKeyID: authDetails.userKeyID,
                getUserKeyID: null,
                fromDate: fromDate, // Use the passed fromDate or a default
                toDate: toDate, // Use the passed toDate or a default
                getUserKeyID: getUserKeyID,
                attendanceStatus: attendanceStatus,
            });
            if (response.statusCode === 200) {
                setLoader(false);
                const list = response.responseData?.data;
                setAttendanceListCount(response.totalCount);
                setAttendanceList(list);
            } else {
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const [selectedUser, setSelectedUser] = useState(null); // State for selected user

    const handleUserChange = (selectedOption) => {
        const getUserKeyID = selectedOption ? selectedOption.value : null; // Get selected user ID
        setSelectedTaskUser(getUserKeyID); // Update state with selected user ID
        setTaskCurrentPage(1);
        // Call both reports with the selected user ID
        GetTaskReportData(
            1,
            taskSearch,
            getUserKeyID,
            selectedJobKeyID,
            fromDate,
            toDate,
            null,
            selectedTaskProjectID
        ); // Fetch Task Report
    };

    const handleJobReportUserChange = (selectedOption) => {
        const getUserKeyID = selectedOption ? selectedOption.value : null;
        setSelectedTaskUser(getUserKeyID);
        setJobReportCurrentPage(1);
        GetJobReportListData(
            1,
            JobReportSearch,
            selectedProjectID, // keep project filter
            selectedStatusID, // keep status filter
            selectedServiceKeyID, // keep service filter
            getUserKeyID // pass user filter
        );
    };


    const handleAttendanceUserChange = (selectedOption) => {
        const getUserKeyID = selectedOption ? selectedOption.value : null; // Get selected user ID
        setSelecteduserKeyID(getUserKeyID); // Update state with selected user ID
        setAttendanceListCurrentPage(1);
        GetAttendanceReportData(
            1,
            AttendanceListSearch,
            fromDate,
            toDate,
            getUserKeyID,
            attandanceStatusID === 1 ? "Present" : "Absent"
        ); // Fetch Team Performance Report
    };

    const handleAttendanceStatusChange = (selectedOption) => {
        const statusID = selectedOption ? selectedOption.value : null; // Get selected user ID
        setAttandanceStatusID(statusID); // Update state with selected user ID
        setAttendanceListCurrentPage(1);
        GetAttendanceReportData(
            1,
            AttendanceListSearch,
            fromDate,
            toDate,
            selecteduserKeyID,
            statusID === 1 ? "Present" : "Absent"
        );
    };

    const handleClientUserChange = (selectedOption) => {
        const clientKeyID = selectedOption ? selectedOption.value : null;
        setSelectedClientID(clientKeyID);
        setClientFinancialListCurrentPage(1);
        GetClientFinancialReportData(
            1,
            ClientFinancialListSearch,
            clientKeyID,
            selectedProjectStageID
        );
    };

    const handleStageChange = (selectedOption) => {
        const projectStageKeyID = selectedOption ? selectedOption.value : null;
        setSelectedProjectStageID(projectStageKeyID);
        setClientFinancialListCurrentPage(1);
        GetClientFinancialReportData(
            1,
            ClientFinancialListSearch,
            selectedClientID,
            projectStageKeyID
        );
    };



    const GetJobLookupListData = async (clientProjectID = null) => {
        try {
            // Pass clientProjectID or null to API
            const data = await GetJobLookupList(
                authDetails.userKeyID,
                clientProjectID
            );

            if (data?.statusCode === 200 && data?.responseData?.data) {
                const List = data.responseData.data.map((item) => ({
                    value: item.jobKeyID,
                    label: item.jobName,
                }));
                setJobLookupList(List);
            } else {
                setJobLookupList([]); // Clear if no data
            }
        } catch (error) {
            console.log(error);
            setJobLookupList([]);
        }
    };

    const GetClientLookupListData = async () => {
        try {
            const data = await GetClientLookupList(
                PanalModuleName,
                authDetails.userKeyID
            );

            if (data?.statusCode === 200 && data?.responseData?.data) {
                const List = data.responseData.data.map((item) => ({
                    value: item.clientKeyID,
                    label: item.clientName,
                    clientCode: item.clientCode,
                    accountManagerUserName: item.accountManagerUserName,
                    projects: item.projects.map((project) => ({
                        projectName: project.projectName,
                        services: project.serviceLookupLists.map((service) => ({
                            value: service.serviceKeyID,
                            label: service.serviceName,
                        })),
                    })),
                }));

                setClientLookupList(List);
                console.log("Client Lookup List:", List); // Log the populated list for debugging
            } else {
                console.log("No data found or status code is not 200.");
            }
        } catch (error) {
            console.error("Error fetching client lookup list:", error);
        }
    };

    const GetServiceLookupListData = async () => {
        try {
            const data = await GetServiceLookupList(
                PanalModuleName,
                authDetails.userKeyID
            );
            if (data?.statusCode === 200 && data?.responseData?.data) {
                const List = data.responseData.data.map((item) => ({
                    value: item.serviceKeyID, // Replace 'id' with the actual field name
                    label: item.serviceName, // Replace 'name' with the actual field name
                }));
                setServiceLookupList(List);
                // setServiceKeyIDs(List.map((item) => item.value))
            }
        } catch (error) {
            console.log(error);
        }
    };


    const attendanceBtnClick = () => {
        setOpenLeavePopupModel(true);
    };

    //1 tab
    const handleExportClientSummaryReport = () => {
        const wb = XLSX.utils.book_new();
        const titleText = "Title: Payment Summary Report";
        const headers = [
            "Company Name",
            "Client Name",
            "Project Name",
            "Project Stage",
            "Project Start Date",
            "Project End Date",
            "Time Line (In Days)",
            "Price (Rs)",
            "Payment Received (Rs)",
            "Due Payment (Rs)",
        ];

        const data = ClientFinancialList.map((row) => [
            row.companyName || "-",
            row.clientName || "-",
            row.projectName || "-",
            row.projectStageName || "-",
            row.projectStartDate
                ? new Date(row.projectStartDate).toLocaleDateString()
                : "-",
            row.projectEndDate
                ? new Date(row.projectEndDate).toLocaleDateString()
                : "-",
            row.timeLineInDays || "-",
            `Rs ${row.price || "0"}`,
            `Rs ${row.paymentReceived || "0"}`,
            `Rs ${row.duePayment || "0"}`,
        ]);

        const ws_data = [[titleText], [], headers, ...data];
        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merge Title
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14, color: { rgb: "000000" } },
            alignment: { horizontal: "center", vertical: "center" },
        };

        // Header styling (row 2 = index 2)
        headers.forEach((_, col) => {
            const cellAddr = XLSX.utils.encode_cell({ c: col, r: 2 });
            if (ws[cellAddr]) {
                ws[cellAddr].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    fill: { fgColor: { rgb: "CFE2F3" } }, // soft blue header
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                };
            }
        });

        // Body rows styling
        for (let r = 3; r < data.length + 3; r++) {
            for (let c = 0; c < headers.length; c++) {
                const cellAddr = XLSX.utils.encode_cell({ c, r });
                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { color: { rgb: "000000" } },
                        alignment: { horizontal: "left", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };

                    // Optional: alternate row coloring (zebra style)
                    if ((r - 3) % 2 === 1) {
                        ws[cellAddr].s.fill = { fgColor: { rgb: "F9F9F9" } };
                    }
                }
            }
        }

        // Column widths
        ws["!cols"] = headers.map((header) => ({
            wch: header.length + 10, // Adjust based on your content
        }));

        XLSX.utils.book_append_sheet(wb, ws, "Payment Summary Report");
        XLSX.writeFile(wb, "Payment_Summary_Report.xlsx");
    };

    //2 tab
    const handleJobExport = () => {
        const wb = XLSX.utils.book_new();

        const titleText = "Title: Job Report";
        const headers = [
            "Job Code",
            "Job Title",
            "Job Status",
            "Service Name",
            "Project Name",
            "Account Manager",
            "Number Of Tasks",
            "Pending Tasks",
            "Completed Tasks",
            "Budgeted Hours",
            "Reviewed Hours",
            "Allocated To",
            "Total Hours",
            "Completion Date",
            "Rating (/5)",
        ];

        const data = JobReportList.map((row) => [
            row.jobCode || "-",
            row.jobName || "-",
            row.jobStatus || "-",
            row.serviceName || "-",
            row.projectName || "-",
            row.accountManager || "-",
            row.totalTasks || "0",
            row.pendingTasks || "0",
            row.completedTasks || "0",
            `${row.budgetedHours || "0"} hrs`,
            `${row.totalReviewTime || "0"} hrs`,
            `${row.actualHours || "0"} hrs`,
            row.allocatedToUser || "-",
            row.endDate ? new Date(row.endDate).toLocaleDateString() : "-",
            `${row.rating || "0"}/5`,
        ]);

        const ws_data = [[titleText], [], headers, ...data];

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merge title row
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center", vertical: "center" },
        };

        // Header row styling (row 2 / index 2)
        headers.forEach((_, col) => {
            const cellAddr = XLSX.utils.encode_cell({ c: col, r: 2 });
            if (ws[cellAddr]) {
                ws[cellAddr].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    fill: { fgColor: { rgb: "CFE2F3" } }, // Light blue
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                };
            }
        });

        // Data row styling
        for (let r = 3; r < data.length + 3; r++) {
            for (let c = 0; c < headers.length; c++) {
                const cellAddr = XLSX.utils.encode_cell({ c, r });
                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { color: { rgb: "000000" } },
                        alignment: { horizontal: "left", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };

                    // Zebra styling for alternating rows
                    if ((r - 3) % 2 === 1) {
                        ws[cellAddr].s.fill = { fgColor: { rgb: "F9F9F9" } };
                    }
                }
            }
        }

        // Column widths for readability
        ws["!cols"] = headers.map((h) => ({ wch: h.length + 8 }));

        XLSX.utils.book_append_sheet(wb, ws, "Job Report");
        XLSX.writeFile(wb, "Job_Report.xlsx");
    };

    //3 tab
    const handleExportTaskReport = () => {
        const wb = XLSX.utils.book_new();
        const titleText = "Title: Task Report";

        const headers = [
            "Task Name",
            "Job Title",
            "Project Name",
            "Assigned To",
            "Assign Date",
            "Completion Date",
            "Budgeted Hours",
            "Total Hours",
            "Status",
        ];

        const data = taskList.map((task) => [
            task.taskName || "-",
            task.jobName || "-",
            task.projectName || "-",
            task.userName || "-",
            task.startDate ? new Date(task.startDate).toLocaleDateString() : "-",
            task.endDate ? new Date(task.endDate).toLocaleDateString() : "-",
            `${task.budgetedHours || "0"} hrs`,
            `${task.totalTime || "0"} hrs`,
            task.taskStatus || "-",
        ]);

        const ws_data = [[titleText], [], headers, ...data];
        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merge the title across all header columns
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center", vertical: "center" },
        };

        // Header row styling (row index 2)
        headers.forEach((_, col) => {
            const cellAddr = XLSX.utils.encode_cell({ c: col, r: 2 });
            if (ws[cellAddr]) {
                ws[cellAddr].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    fill: { fgColor: { rgb: "CFE2F3" } }, // Light blue header
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                };
            }
        });

        // Body rows styling
        for (let r = 3; r < data.length + 3; r++) {
            for (let c = 0; c < headers.length; c++) {
                const cellAddr = XLSX.utils.encode_cell({ c, r });
                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { color: { rgb: "000000" } },
                        alignment: { horizontal: "left", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };

                    // Zebra row styling (alternate light background)
                    if ((r - 3) % 2 === 1) {
                        ws[cellAddr].s.fill = { fgColor: { rgb: "F9F9F9" } };
                    }
                }
            }
        }

        // Set column widths based on header length
        ws["!cols"] = headers.map((header) => ({
            wch: header.length + 10, // Adjust as needed
        }));

        XLSX.utils.book_append_sheet(wb, ws, "Task Report");
        XLSX.writeFile(wb, "Task_Report.xlsx");
    };



    //7 tab

    const handleExportTeamPerformanceReport = () => {
        const wb = XLSX.utils.book_new();
        const titleText = "Title: Team Performance Report";

        const headers = [
            "Name",
            "Total Days",
            "Present Days",
            "Total Present hrs",
            "Allocated Job",
            "Allocated Task",
            "Completed Task",
            "Completion Percentage",
            "Average Budgeted Hr",
            "Average Completion Hr",
        ];

        const data = teamPerforanceList.map((row) => [
            row.userName || "-",
            row.totalDays || "0",
            row.presentDays || "0",
            row.totalPresentHours || "0",
            row.allocatedJobs || "0",
            row.allocatedTask || "0",
            row.completedTask || "0",
            `${row.completionPercentage || "0"}%`,
            `${row.totalBudgetedHours || "0"} hrs`,
            `${row.totalCompletionHours || "0"} hrs`,
        ]);

        const ws_data = [[titleText], [], headers, ...data];
        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        // Merge title row
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center", vertical: "center" },
        };

        // Header styling (row index 2)
        headers.forEach((_, col) => {
            const cellAddr = XLSX.utils.encode_cell({ c: col, r: 2 });
            if (ws[cellAddr]) {
                ws[cellAddr].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    fill: { fgColor: { rgb: "CFE2F3" } }, // Light blue
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                };
            }
        });

        // Data styling (from row 3 onwards)
        for (let r = 3; r < data.length + 3; r++) {
            for (let c = 0; c < headers.length; c++) {
                const cellAddr = XLSX.utils.encode_cell({ c, r });
                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { color: { rgb: "000000" } },
                        alignment: { horizontal: "left", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };

                    // Zebra striping
                    if ((r - 3) % 2 === 1) {
                        ws[cellAddr].s.fill = { fgColor: { rgb: "F9F9F9" } };
                    }
                }
            }
        }

        // Auto column widths
        ws["!cols"] = headers.map((h) => ({ wch: h.length + 10 }));

        XLSX.utils.book_append_sheet(wb, ws, "Team Performance Report");
        XLSX.writeFile(wb, "Team_Performance_Report.xlsx");
    };

    // Function to show Job Report tab with relevant data
    const showJobReport = (clientProjectID, projectName) => {
        setVisibleTabs((prev) => {
            if (!prev.includes(ReportEnum.JobReport))
                return [...prev, ReportEnum.JobReport];
            return prev;
        });
        setActiveTab(ReportEnum.JobReport);
        setSelectedProjectID(clientProjectID);
        setJobReportCurrentPage(1);
        GetJobReportListData(1, "", clientProjectID);
    };



    // Function to handle job selection from the dropdown
    const handleJobSelection = (selectedOption) => {
        const jobID =
            selectedOption && selectedOption.value !== null
                ? selectedOption.value
                : null;
        setSelectedJobKeyID(jobID);
        setTaskCurrentPage(1);
        GetTaskReportData(
            1,
            taskSearch,
            selectedTaskUser,
            jobID,
            fromDate,
            toDate,
            null,
            selectedTaskProjectID
        );
    };

    const ProjectLookUpListWithAll = [
        { value: null, label: "All" }, // New All option
        ...ProjectLookUpList, // Spread your existing options
    ];

    const handleViewLog = (task) => {
        // Store the currently active tab in local storage
        localStorage.setItem("ReportselectedTab", activeTab);

        navigate("/TaskViewLog", {
            state: {
                taskLogs: task.taskLog,
                jobName: task.jobName,
                taskName: task.taskName,
                projectName: task.projectName,
                taskKeyID: task.taskKeyID,
                jobOwner: task.jobOwner,
                selectedTaskUser: selectedTaskUser,
                selectedJobKeyID: selectedJobKeyID,
                fromDate: fromDate,
                toDate: toDate,
            },
        });
    };


    const permissionModuleList =
        JSON.parse(localStorage.getItem("permissions")) || [];

    const hasTabAccess = (compareName) => {
        return permissionModuleList.some(
            (module) =>
                module.compareName?.toLowerCase() === compareName?.toLowerCase() &&
                module.isaccessible === 1 // ✅ correct key
        );
    };

    return (
        <div className="bg-gray-50 mx-auto mb-10">
            <div className="bg-white shadow-lg rounded-lg px-6">
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                    }}
                    className="p-4 overflow-x-auto"
                >
                    <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-4 border-b text-12">
                        <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-4 border-b text-12">
                            {allTabs
                                .filter((tab) => hasTabAccess(tab.compareName))
                                .map((tab) => (
                                    <button
                                        key={tab.id}
                                        className={`px-4 py-2 whitespace-nowrap border-b-2 ${activeTab === tab.id
                                            ? "text-[#135EA0] border-b-2 border-[#135EA0] font-semibold"
                                            : "border-transparent text-gray-900"
                                            }`}
                                        onClick={() => {
                                            handleChangeTab(tab.id);
                                        }}
                                    >
                                        {tab.label}
                                    </button>
                                ))}
                        </div>
                    </div>
                </div>

                {/* Tab Content */}


                {activeTab === DashboardExpenseReportEnum.ExpenseReport && (
                    <ExpenseReportListComponent />
                )}

                {/* Tender report starts  */}
                {activeTab === DashboardExpenseReportEnum.TenderReport && (

                    <TenderReportListComponent />
                )}
                {/* Tender report ends  */}
            </div>
        </div>
    );
}

export default DashboardExpenseList;
